import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './en.json'
import fr from './fr.json'
import pl from './pl.json'
import es from './es.json'

const STORAGE_LANG_KEY = 'appLanguage'

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      pl: { translation: pl },
      es: { translation: es },
    },
    lng: (typeof window !== 'undefined' && (() => { try { return localStorage.getItem(STORAGE_LANG_KEY); } catch (_) { return null; } })()) || 'fr',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })

if (typeof window !== 'undefined') {
  i18n.on('languageChanged', (lng) => {
    localStorage.setItem(STORAGE_LANG_KEY, lng)
  })
}

export default i18n
